// Hitkeep ecommerce-events: view_item, add_to_cart, begin_checkout.
// purchase kan hier niet vandaan komen - dat gebeurt op de checkout van Shopify,
// buiten het theme. Zie docs/hitkeep-purchase-pixel.js.
(() => {
  const cfg = window.__hk || {};
  const CUR = cfg.cur || 'EUR';

  // hk.js laadt async, dus window.hk.event bestaat vaak nog niet als het eerste
  // event al klaar staat. Bufferen tot de tracker er is; bij DNT of een bot zet
  // hk.js zelf een noop neer, dus dan verdwijnt de queue vanzelf in het niets.
  const queue = [];
  let polling = false;
  function send(name, props) {
    if (window.hk?.event) { window.hk.event(name, props); return; }
    queue.push([name, props]);
    if (!polling) { polling = true; drain(0); }
  }
  function drain(tries) {
    if (window.hk?.event) {
      polling = false;
      queue.splice(0).forEach(([n, p]) => window.hk.event(n, p));
      return;
    }
    if (tries > 40) { polling = false; queue.length = 0; return; } // 10s: tracker geblokkeerd
    setTimeout(() => drain(tries + 1), 250);
  }
  window.hkEvent = send;

  const money = (cents) => Math.round(Number(cents) || 0) / 100;

  // Shopify cart line (uit /cart/add.js of /cart.js) -> hitkeep item.
  function toItem(line) {
    const item = {
      item_id: String(line.product_id ?? line.id ?? ''),
      item_name: line.product_title || line.title || '',
      quantity: Number(line.quantity) || 1,
      price: money(line.price ?? line.final_price ?? 0),
    };
    if (line.product_type) item.category = line.product_type;
    return item;
  }

  // ── view_item ──
  if (cfg.item) {
    send('view_item', {
      item_id: String(cfg.item.id),
      item_name: cfg.item.name,
      category: cfg.item.category || undefined,
      price: money(cfg.item.price_cents),
      currency: CUR,
    });
  }

  // ── add_to_cart ──
  // Eén event per regel, zoals de guide: quantity zit in het item zelf.
  window.hkAddToCart = (payload) => {
    const lines = Array.isArray(payload) ? payload : payload?.items || [payload];
    lines.filter(Boolean).forEach((line) => {
      send('add_to_cart', { ...toItem(line), currency: CUR });
    });
    tagCart(null);
  };

  // ── Sessie doorgeven aan de checkout ──
  // De custom pixel op de bedanktpagina draait in een sandbox en kan de
  // sessionStorage van deze storefront niet lezen. Zonder koppeling landt
  // purchase op een losse sessie en klopt de bronrapportage niet. Daarom zetten
  // we de hk-sessie als cart-attribuut: die reist mee naar de order en de pixel
  // leest hem terug uit checkout.attributes.
  let tagged = null;
  function sessionId() {
    try { return (sessionStorage.getItem('hk_session') || '').split('|')[0] || null; } catch (e) { return null; }
  }
  function tagCart(known) {
    const sid = sessionId();
    if (!sid || tagged === sid) return;
    if (known?.attributes?.hk_sid === sid) { tagged = sid; return; }
    tagged = sid;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { hk_sid: sid } }),
      keepalive: true,
    }).catch(() => { tagged = null; });
  }

  // ── begin_checkout ──
  // De klik op Afrekenen navigeert meteen weg, dus de cart moet al bekend zijn.
  // Snapshot komt uit renderCart() in cart.js, uit een fetch op de cartpagina en
  // uit een pre-fetch zodra de muis/focus op een afrekenknop landt.
  let cart = null;
  let pending = null;
  window.hkSetCart = (c) => { cart = c; };
  function loadCart() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => { cart = c; pending = null; tagCart(c); return c; })
      .catch(() => { pending = null; return null; });
    return pending;
  }
  if (cfg.page === 'cart') loadCart();

  const CHECKOUT_SEL = '[name="checkout"], a[href^="/checkout"], [data-hk-checkout]';
  let sent = false;
  function beginCheckout() {
    if (sent || !cart || !cart.item_count) return;
    sent = true;
    const discount = (cart.cart_level_discount_applications || [])[0]
      || (cart.discount_applications || [])[0];
    const props = {
      value: money(cart.total_price),
      currency: cart.currency || CUR,
      items_count: cart.item_count,
      items: (cart.items || []).map(toItem),
    };
    // cart.token komt soms als 'token?key=...' binnen; alleen de token zelf.
    if (cart.token) props.checkout_id = String(cart.token).split('?')[0];
    if (discount?.title) props.coupon = discount.title;
    send('begin_checkout', props);
  }
  window.hkBeginCheckout = beginCheckout;

  ['pointerdown', 'focusin'].forEach((type) => {
    document.addEventListener(type, (e) => {
      if (e.target.closest?.(CHECKOUT_SEL)) loadCart();
    }, true);
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest(CHECKOUT_SEL)) beginCheckout();
  }, true);
  document.addEventListener('submit', (e) => {
    if (e.target.querySelector?.('[name="checkout"]')) beginCheckout();
  }, true);
})();
